document.addEventListener("DOMContentLoaded", function () {
  let desktopInitialized = false;
  let mobileInitializes = false;
  let searchFlyoutInitialized = false;

  // Assigned by the desktop branch of initFlyoutMenu() so the search code, which
  // is bound only once, can reuse the menu's single close path.
  let closeDesktopFlyout = function () {};

  // Keep the desktop search toggle in sync with the panel it controls.
  function syncSearchToggles() {
    const panel = document.querySelector('.flyout-panel[data-parent="search"]');
    const isOpen = !!(panel && panel.classList.contains("active"));

    document
      .querySelectorAll('.navbar-search-toggle[data-search-scope="desktop"]')
      .forEach((toggle) => {
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
  }

  function initFlyoutMenu() {
    const isDesktop = window.innerWidth >= 992;
    if (isDesktop && !desktopInitialized) {
      if (mobileInitializes) {
        cleanupMobile();
        mobileInitializes = false;
      }

      const navmenu = document.querySelector(".navbar-menu.level-0");
      const overlay = document.querySelector(".flyout-overlay");
      const panelWrapper = document.querySelector(".flyout-overlay-wrapper");
      const panels = document.querySelectorAll(".flyout-panel");

      const flyoutLinks = document.querySelectorAll(
        ".flyout-menu-item.level-0  > a",
      );
      const flyoutButtons = document.querySelectorAll(
        ".flyout-menu-item.level-0.has-children > button",
      );

      const nextButtonsDesktop = document.querySelectorAll(
        ".column-2 .flyout-next-desktop",
      );
      const nextLinksDesktop = document.querySelectorAll(
        ".column-2 .flyout-menu-item > a",
      );
      const submenus = document.querySelectorAll(
        ".column-3 .flyout-column-submenu",
      );
      const submenuLinks = document.querySelectorAll(
        ".column-3 .flyout-menu-item > a",
      );

      document.addEventListener("click", (e) => {
        const isInsideMenu =
          e.target.closest(".flyout-overlay-wrapper") ||
          e.target.closest(".flyout-menu-item.level-0") ||
          // The search toggle owns its own open/close logic. Without this it
          // would be closed again here, in the bubble phase, right after it
          // opened the panel.
          e.target.closest(".navbar-search-toggle");

        if (!isInsideMenu) {
          closeFlyout();
        }
      });

      let activePanel = null;
      let column1 = null;
      let column2 = null;
      let column3 = null;
      let columnBaffer = null;

      let panelHeightValue = null;
      let initalPanelHeightValue = null;
      let activeItem = null;

      let isHoverColumn2 = false;
      let isHoverColumn3 = false;
      let isHoverColumnBaffer = false;

      let closeTimeout;
      let hideTimeout;
      let fixedHeightTimeout;

      let lastStateFlyout = null;
      let lastStateNextButtons = null;

      function closeFlyout() {
        activePanel = null;

        // Pending timers still write heights after the close, so drop them.
        clearTimeout(closeTimeout);
        clearTimeout(hideTimeout);
        clearTimeout(fixedHeightTimeout);

        overlay.classList.remove("active");
        overlay.style.opacity = "0";
        overlay.style.visibility = "hidden";

        flyoutButtons.forEach((btn) => btn.classList.remove("active-hover"));
        // Remove "active" class when Menu is not active anymore.
        document.querySelectorAll(".flyout-panel.active").forEach((panel) => {
          panel.classList.remove("active");
          panel.style.display = "none";
        });

        // Clear the height overrides left behind by the "restore last third
        // level" path. .panel-fixed-height uses !important, so the next panel
        // (the content-sized search panel in particular) cannot outgrow it.
        panelWrapper.classList.remove("panel-fixed-height");
        panelWrapper.style.removeProperty("--panel-height");
        panelWrapper.style.height = "";
        document.querySelectorAll(".flyout-panel").forEach((panel) => {
          panel.classList.remove("panel-fixed-height-wrapper");
          panel.style.height = "";
        });

        syncSearchToggles();
      }

      closeDesktopFlyout = closeFlyout;

      function scheduleClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(() => {
          closeFlyout();
        }, 100);
      }

      function cancelClose() {
        clearTimeout(closeTimeout);
      }

      function setActivePanel(panelId) {
        document.querySelectorAll(".flyout-panel").forEach((panel) => {
          panel.classList.remove("active");
          panel.style.display = "none";
        });
        // Opening a menu panel implicitly closed search: reset its toggle. This
        // is the single choke point every menu-open path goes through.
        syncSearchToggles();

        activePanel = document.querySelector(
          `.flyout-panel[data-parent="${panelId}"]`,
        );
        if (!activePanel) return;

        activePanel.classList.add("active");
        activePanel.style.display = "block";

        column1 = activePanel.querySelector(".flyout-column.column-1");
        column2 = activePanel.querySelector(".flyout-column.column-2");
        column3 = activePanel.querySelector(".flyout-column.column-3");
        columnBaffer = activePanel.querySelector(".flyout-column-baffer");

        requestAnimationFrame(() => {
          const column1Height = column1?.offsetHeight || 0;
          const column2Height = column2?.offsetHeight || 0;
          const column3Height = column3?.offsetHeight || 0;
          const panelHeight = activePanel.offsetHeight;

          initalPanelHeightValue = Math.max(
            panelHeight,
            column1Height,
            column2Height,
            column3Height,
          );
          panelWrapper.style.height = `${initalPanelHeightValue}px`;
          activePanel.style.height = `${initalPanelHeightValue}px`;
          wireHoverTracking();
        });
      }

      function wireHoverTracking() {
        attachHover(
          column2,
          () => (isHoverColumn2 = true),
          () => (isHoverColumn2 = false),
        );
        attachHover(
          columnBaffer,
          () => (isHoverColumnBaffer = true),
          () => (isHoverColumnBaffer = false),
        );
      }

      function attachHover(el, onEnter, onLeave) {
        if (!el) return;
        el.addEventListener("pointerenter", () => {
          onEnter();
          clearTimeout(hideTimeout);
        });
        el.addEventListener("pointerleave", () => {
          onLeave();
          maybeHideSubmenu();
        });
      }

      function maybeHideSubmenu() {
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(() => {
          if (!isHoverColumn2 && !isHoverColumn3 && !isHoverColumnBaffer) {
            document
              .querySelectorAll(".flyout-next-desktop")
              .forEach((i) => i.classList.remove("active", "active-hover"));
            activeItem = null;
            panelWrapper.style.height = `${Math.max(panelHeightValue, initalPanelHeightValue)}px`;
          }
        }, 50);
      }

      flyoutButtons.forEach((item) => {
        item.addEventListener("click", () => {
          const id = item.getAttribute("data-id");

          if (activePanel && activePanel.getAttribute("data-parent") === id) {
            closeFlyout();
            activePanel = null;
            return;
          }

          const storedID = localStorage.getItem("lastThirdLevelID");
          const storedParentID = storedID ? storedID.charAt(0) : null;
          if (id === storedParentID) {
            panels.forEach((panel) => panel.classList.remove("active"));
            setActivePanel(storedParentID);
            const targetPanel = document.querySelector(
              `.flyout-panel[data-parent="${storedParentID}"]`,
            );

            if (targetPanel) {
              targetPanel.classList.add("active");
            }

            const a = document.querySelectorAll(
              ".flyout-column.column-2 .flyout-column-submenu",
            );
            a.forEach((sub) => sub.classList.remove("active"));

            const targetSubmenuA = document.getElementById(
              `column-submenu-${storedParentID}`,
            );

            flyoutButtons.forEach((btn) =>
              btn.classList.remove("active-hover"),
            );
            item.classList.add("active-hover");

            document
              .querySelectorAll(
                ".flyout-column.column-3 .flyout-column-submenu",
              )
              .forEach((sub) => sub.classList.remove("active"));

            if (targetSubmenuA) {
              targetSubmenuA.classList.add("active");

              const activePanel = document.querySelector(
                ".flyout-panel.active",
              );
              if (activePanel) {
                const matchLink = Array.from(
                  document.querySelectorAll(
                    ".flyout-panel.active .column-3 .third-level[data-parent]",
                  ),
                ).find((link) => {
                  const targetData = link.getAttribute("data-parent");
                  return String(targetData) === String(storedID);
                });
                if (matchLink) {
                  const col3 = activePanel.querySelector(
                    ".flyout-column.column-3",
                  );
                  if (col3) {
                    col3.classList.add("active", "show-on-hover");
                  }
                  const colthird = activePanel.querySelector(
                    `.flyout-column-submenu.third-level[data-parent="${storedID}"]`,
                  );
                  if (colthird) {
                    colthird.classList.add("active");
                  }
                }
              }
            }
            const column1Height = column1?.offsetHeight || 0;
            const column2Height = column2?.offsetHeight || 0;
            const column3Height = column3?.offsetHeight || 0;
            const panelHeight = targetPanel.offsetHeight;
            const divSubmenu =
              activePanel.querySelector(
                ".flyout-column-submenu.third-level.active",
              )?.offsetHeight || 0;
            panelHeightValue = Math.max(
              panelHeight,
              column1Height,
              column2Height,
              column3Height,
              divSubmenu,
            );

            fixedHeightTimeout = setTimeout(() => {
              panelWrapper.style.setProperty(
                "--panel-height",
                `${panelHeightValue}px`,
              );
              panelWrapper.classList.add("panel-fixed-height");
              targetPanel.classList.add("panel-fixed-height-wrapper");
            }, 50);

            if (overlay) {
              overlay.style.display = "block";
              overlay.style.opacity = "1";
              overlay.style.visibility = "visible";
            }
          } else {
            setActivePanel(id);
            panels.forEach((panel) => panel.classList.remove("active"));

            const targetPanel = document.querySelector(
              `.flyout-panel[data-parent="${id}"]`,
            );

            if (targetPanel) {
              targetPanel.classList.add("active");
              const column1Height = column1?.offsetHeight || 0;
              const column2Height = column2?.offsetHeight || 0;
              const column3Height = column3?.offsetHeight || 0;
              const panelHeight = targetPanel.offsetHeight;
              const divSubmenu = document.querySelector(
                ".flyout-column.column-2 .flyout-column-submenu.active",
              );
              panelHeightValue = Math.max(
                panelHeight,
                column1Height,
                column2Height,
                column3Height,
                divSubmenu,
              );
              panelWrapper.style.height = `${panelHeightValue}px`;
            }

            const a = document.querySelectorAll(
              ".flyout-column.column-2 .flyout-column-submenu",
            );
            a.forEach((sub) => sub.classList.remove("active"));

            const targetSubmenuA = document.getElementById(
              `column-submenu-${id}`,
            );

            flyoutButtons.forEach((btn) =>
              btn.classList.remove("active-hover"),
            );
            item.classList.add("active-hover");

            document
              .querySelectorAll(
                ".flyout-column.column-3 .flyout-column-submenu",
              )
              .forEach((sub) => sub.classList.remove("active"));

            if (targetSubmenuA) {
              targetSubmenuA.classList.add("active");
            }

            if (overlay) {
              overlay.style.display = "block";
              overlay.style.opacity = "1";
              overlay.style.visibility = "visible";
            }
          }
        });
        item.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();

            const id = item.getAttribute("data-id");
            const storedID = localStorage.getItem("lastThirdLevelID");
            const storedParentID = storedID ? storedID.charAt(0) : null;
            if (id === storedParentID) {
              panels.forEach((panel) => panel.classList.remove("active"));
              setActivePanel(storedParentID);
              const targetPanel = document.querySelector(
                `.flyout-panel[data-parent="${storedParentID}"]`,
              );

              if (targetPanel) {
                targetPanel.classList.add("active");
              }

              const a = document.querySelectorAll(
                ".flyout-column.column-2 .flyout-column-submenu",
              );
              a.forEach((sub) => sub.classList.remove("active"));

              const targetSubmenuA = document.getElementById(
                `column-submenu-${storedParentID}`,
              );

              flyoutButtons.forEach((btn) =>
                btn.classList.remove("active-hover"),
              );
              item.classList.add("active-hover");

              document
                .querySelectorAll(
                  ".flyout-column.column-3 .flyout-column-submenu",
                )
                .forEach((sub) => sub.classList.remove("active"));

              if (targetSubmenuA) {
                targetSubmenuA.classList.add("active");

                const activePanel = document.querySelector(
                  ".flyout-panel.active",
                );
                if (activePanel) {
                  const matchLink = Array.from(
                    document.querySelectorAll(
                      ".flyout-panel.active .column-3 .third-level[data-parent]",
                    ),
                  ).find((link) => {
                    const targetData = link.getAttribute("data-parent");
                    return String(targetData) === String(storedID);
                  });
                  if (matchLink) {
                    const col3 = activePanel.querySelector(
                      ".flyout-column.column-3",
                    );
                    if (col3) {
                      col3.classList.add("active", "show-on-hover");
                    }
                    const colthird = activePanel.querySelector(
                      `.flyout-column-submenu.third-level[data-parent="${storedID}"]`,
                    );
                    if (colthird) {
                      colthird.classList.add("active");
                    }
                  }
                }
              }
              const column1Height = column1?.offsetHeight || 0;
              const column2Height = column2?.offsetHeight || 0;
              const column3Height = column3?.offsetHeight || 0;
              const panelHeight = targetPanel.offsetHeight;
              const divSubmenu =
                activePanel.querySelector(
                  ".flyout-column-submenu.third-level.active",
                )?.offsetHeight || 0;
              panelHeightValue = Math.max(
                panelHeight,
                column1Height,
                column2Height,
                column3Height,
                divSubmenu,
              );

              fixedHeightTimeout = setTimeout(() => {
                panelWrapper.style.setProperty(
                  "--panel-height",
                  `${panelHeightValue}px`,
                );
                panelWrapper.classList.add("panel-fixed-height");
              }, 50);

              if (overlay) {
                overlay.style.display = "block";
                overlay.style.opacity = "1";
                overlay.style.visibility = "visible";
              }
            } else {
              setActivePanel(id);
              panels.forEach((panel) => panel.classList.remove("active"));

              const targetPanel = document.querySelector(
                `.flyout-panel[data-parent="${id}"]`,
              );

              if (targetPanel) {
                targetPanel.classList.add("active");
                const column1Height = column1?.offsetHeight || 0;
                const column2Height = column2?.offsetHeight || 0;
                const column3Height = column3?.offsetHeight || 0;
                const panelHeight = targetPanel.offsetHeight;
                const divSubmenu = document.querySelector(
                  ".flyout-column.column-2 .flyout-column-submenu.active",
                );
                panelHeightValue = Math.max(
                  panelHeight,
                  column1Height,
                  column2Height,
                  column3Height,
                  divSubmenu,
                );
                panelWrapper.style.height = `${panelHeightValue}px`;
              }

              const a = document.querySelectorAll(
                ".flyout-column.column-2 .flyout-column-submenu",
              );
              a.forEach((sub) => sub.classList.remove("active"));

              const targetSubmenuA = document.getElementById(
                `column-submenu-${id}`,
              );

              flyoutButtons.forEach((btn) =>
                btn.classList.remove("active-hover"),
              );
              item.classList.add("active-hover");

              document
                .querySelectorAll(
                  ".flyout-column.column-3 .flyout-column-submenu",
                )
                .forEach((sub) => sub.classList.remove("active"));

              if (targetSubmenuA) {
                targetSubmenuA.classList.add("active");
              }

              if (overlay) {
                overlay.style.display = "block";
                overlay.style.opacity = "1";
                overlay.style.visibility = "visible";
              }
            }
          }
          if (event.key === "Escape") {
            closeFlyout();
          }
        });
      });

      nextButtonsDesktop.forEach((btn) => {
        btn.addEventListener("pointerenter", (e) => {
          isHoverColumn2 = true;
          nextButtonsDesktop.forEach((i) => i.classList.remove("active-hover"));
          btn.classList.add("active-hover");

          const targetId = btn.getAttribute("data-target");
          const submenu = document.getElementById(targetId);

          submenus.forEach((menu) => {
            menu.classList.remove("active");
          });

          if (submenu) {
            submenu.classList.add("active");
            activeItem = submenu;
            const heightSubmenu = submenu.offsetHeight;
            const divFlyoutColumnsHeight = document.querySelector(
              ".flyout-panel.active .flyout-columns",
            ).offsetHeight;
            const divFlyout = document.querySelector(".flyout-panel.active");
            const divFlyoutHeight = document.querySelector(
              ".flyout-panel.active",
            ).offsetHeight;
            if (divFlyoutHeight > heightSubmenu) {
              divFlyout.style.height = `${divFlyoutColumnsHeight + 30}px`;
              panelWrapper.style.height = `${divFlyoutColumnsHeight + 30}px`;
            } else {
              divFlyout.style.height = `${Math.max(heightSubmenu)}px`;
              panelWrapper.style.height = `${Math.max(heightSubmenu)}px`;
            }
          }
          const thirdColumn = document.querySelector(
            ".flyout-column .column-3",
          );
          if (thirdColumn) {
            thirdColumn.style.display = "block";
          }
        });
        btn.addEventListener("pointerleave", (e) => {
          isHoverColumn2 = true;
          maybeHideSubmenu();
        });
        btn.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            isHoverColumn2 = true;
            nextButtonsDesktop.forEach((i) =>
              i.classList.remove("active-hover"),
            );
            btn.classList.add("active-hover");

            const targetId = btn.getAttribute("data-target");
            const submenu = document.getElementById(targetId);

            submenus.forEach((menu) => {
              menu.classList.remove("active");
            });

            if (submenu) {
              submenu.classList.add("active");
              activeItem = submenu;
              const heightSubmenu = submenu.offsetHeight;
              const column1Height = column1.offsetHeight;
              const column2Height = column2.offsetHeight;
              const divFlyout = document.querySelector(
                ".flyout-panel.active",
              ).offsetHeight;
              const maxColumn1Column2 = Math.max(
                column1Height,
                column2Height,
                divFlyout,
              );

              panelWrapper.style.height = `${Math.max(maxColumn1Column2, heightSubmenu)}px`;
            }
            const thirdColumn = document.querySelector(
              ".flyout-column .column-3",
            );
            if (thirdColumn) {
              thirdColumn.style.display = "block";
            }
          }
          if (e.key === "Escape") {
            document
              .querySelectorAll(".flyout-column.column-2 .flyout-next-desktop")
              .forEach((i) => i.classList.remove("active", "active-hover"));
            document
              .querySelectorAll(".third-level")
              .forEach((i) => i.classList.remove("active", "active-hover"));
          }
        });
        btn.addEventListener("click", () => {
          localStorage.setItem("lastThirdLevel", btn.href);
        });
      });

      nextLinksDesktop.forEach((link) => {
        link.addEventListener("mouseover", (e) => {
          nextLinksDesktop.forEach((i) => i.classList.remove("active-hover"));
          link.classList.add("active-hover");
          nextButtonsDesktop.forEach((i) => i.classList.remove("active-hover"));
          submenus.forEach((menu) => {
            menu.classList.remove("active");
            activeItem = menu;
          });
        });
        link.addEventListener("mouseleave", (e) => {
          nextLinksDesktop.forEach((i) => i.classList.remove("active-hover"));
          link.classList.remove("active-hover");
        });
      });

      document.addEventListener("focusin", (event) => {
        // focusin fires before click on a mouse press. Without this exemption,
        // clicking the search toggle to close would close the panel here and the
        // toggle's own handler would then see a closed panel and re-open it.
        if (
          event.target.closest &&
          event.target.closest(".navbar-search-toggle")
        ) {
          return;
        }

        if (
          navmenu &&
          !navmenu.contains(event.target) &&
          overlay &&
          !overlay.contains(event.target)
        ) {
          closeFlyout();
        }
      });

      submenuLinks.forEach((link) => {
        link.addEventListener("pointerenter", () => {
          link.classList.add("active-hover");
        });
        link.addEventListener("pointerleave", () => {
          link.classList.remove("active-hover");
        });
        link.addEventListener("click", () => {
          localStorage.setItem("lastThirdLevelHref", link.href);

          const parentID = link.closest(".flyout-column-submenu.third-level");
          const parentSubmenuID = parentID.getAttribute("id");

          const parentSubmenuIDnumber = parentSubmenuID.replace(
            "column-submenu-",
            "",
          );
          localStorage.setItem("lastThirdLevelID", parentSubmenuIDnumber);

          link.classList.remove("active-hover");
        });
      });
      desktopInitialized = true;
    } else if (!isDesktop && !mobileInitializes) {
      if (desktopInitialized) {
        cleanupDesktop();
        desktopInitialized = false;
      }

      const search = document.querySelector(".navbar-mobile-search");
      const burger = document.querySelector(".navbar-mobile-burger");
      const close = document.querySelector(".navbar-mobile-close");
      const flyout = document.querySelector(".flyout-menu");
      const nextButtons = document.querySelectorAll(".flyout-next");
      const backButtons = document.querySelectorAll(".flyout-back");
      if (burger && close && flyout) {
        burger.addEventListener("click", () => {
          flyout.classList.add("open");

          burger.style.display = "none";
          if (search) search.style.display = "none";
          close.classList.add("is-visible");
          document.body.classList.add("overflow-hidden");
        });

        close.addEventListener("click", () => {
          flyout.classList.remove("open");
          flyout.classList.remove("show");
          burger.style.display = "";
          // Empty string, not "block": .navbar-mobile-wrapper is a flex box that
          // centres the icon.
          if (search) search.style.display = "";

          close.classList.remove("is-visible");
          document.body.classList.remove("overflow-hidden");
        });
      }

      nextButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          if (window.innerWidth < 992) {
            e.preventDefault();
          }
          const targetId = btn.getAttribute("data-target");
          const submenu = document.getElementById(targetId);
          if (submenu) submenu.classList.add("active");
          flyout.classList.add("submenu-open");
        });
      });

      backButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const closeId = btn.getAttribute("data-back-to");
          const submenu = document.getElementById(closeId);
          if (submenu) submenu.classList.remove("active");
          flyout.classList.remove("submenu-open");
        });
      });
      mobileInitializes = true;
    }
  }

  function cleanupDesktop() {
    document.querySelectorAll(".flyout-panel").forEach((panel) => {
      panel.classList.remove("active", "panel-fixed-height-wrapper");
      // Empty string, not "none": the search panel then falls back to the SCSS.
      panel.style.display = "";
      panel.style.height = "";
    });
    document
      .querySelectorAll(".flyout-column-submenu")
      .forEach((sub) => sub.classList.remove("active"));
    document
      .querySelectorAll(".flyout-menu-item.level-0.has-children > button")
      .forEach((btn) => btn.classList.remove("active-hover"));

    const panelWrapper = document.querySelector(".flyout-overlay-wrapper");
    if (panelWrapper) {
      panelWrapper.classList.remove("panel-fixed-height");
      panelWrapper.style.removeProperty("--panel-height");
      panelWrapper.style.height = "";
    }

    const overlay = document.querySelector(".flyout-overlay");
    if (overlay) {
      overlay.classList.remove("active");
      overlay.style.display = "";
      overlay.style.opacity = "";
      overlay.style.visibility = "";
    }

    syncSearchToggles();
  }

  function cleanupMobile() {
    document
      .querySelectorAll(".flyout-menu")
      .forEach((menu) => menu.classList.remove("open", "show"));

    const searchPanel = document.querySelector(".flyout-search");
    if (searchPanel) searchPanel.classList.remove("open");

    document
      .querySelectorAll('.navbar-search-toggle[data-search-scope="mobile"]')
      .forEach((toggle) => toggle.setAttribute("aria-expanded", "false"));

    const close = document.querySelector(".navbar-mobile-close");
    if (close) close.classList.remove("is-visible");

    // The burger and search handlers set inline display on these; drop it so the
    // desktop/mobile round trip cannot leave an icon hidden.
    [
      ".navbar-mobile-search",
      ".navbar-mobile-burger",
      ".navbar-mobile-close",
    ].forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) element.style.display = "";
    });

    document.body.classList.remove("overflow-hidden");
  }

  /**
   * Search flyout.
   */
  function initSearchFlyout() {
    if (searchFlyoutInitialized) return;

    const desktopToggle = document.querySelector(
      '.navbar-search-toggle[data-search-scope="desktop"]',
    );
    const mobileToggle = document.querySelector(
      '.navbar-search-toggle[data-search-scope="mobile"]',
    );

    if (!desktopToggle && !mobileToggle) return;
    searchFlyoutInitialized = true;

    const desktopPanel = document.querySelector(
      '.flyout-panel[data-parent="search"]',
    );
    const mobilePanel = document.querySelector(".flyout-search");
    const overlay = document.querySelector(".flyout-overlay");
    const panelWrapper = document.querySelector(".flyout-overlay-wrapper");
    const burger = document.querySelector(".navbar-mobile-burger");

    const isDesktopOpen = () =>
      !!(desktopPanel && desktopPanel.classList.contains("active"));
    const isMobileOpen = () =>
      !!(mobilePanel && mobilePanel.classList.contains("open"));

    // Focus the field once the panel is actually focusable.
    function focusInput(panel) {
      const input = panel && panel.querySelector(".search-flyout__input");
      if (!input) return;

      let attempts = 10;
      const tryFocus = () => {
        if (document.activeElement === input) return;
        input.focus();
        attempts -= 1;
        if (attempts > 0 && document.activeElement !== input) {
          requestAnimationFrame(tryFocus);
        }
      };
      requestAnimationFrame(tryFocus);
    }

    function openDesktop() {
      if (!desktopPanel || !overlay || !panelWrapper) return;

      // Closes any open menu panel and clears the height overrides it left.
      closeDesktopFlyout();

      panelWrapper.style.height = "";
      desktopPanel.style.height = "";
      desktopPanel.style.display = "block";
      desktopPanel.classList.add("active");

      overlay.style.display = "block";
      overlay.style.opacity = "1";
      overlay.style.visibility = "visible";

      desktopToggle.setAttribute("aria-expanded", "true");
      focusInput(desktopPanel);
    }

    function closeDesktop(restoreFocus) {
      if (desktopPanel) {
        desktopPanel.classList.remove("active");
        desktopPanel.style.display = "none";
      }
      // Hides the overlay, clears timers and calls syncSearchToggles().
      closeDesktopFlyout();

      if (restoreFocus && desktopToggle) desktopToggle.focus();
    }

    function openMobile() {
      if (!mobilePanel) return;

      mobilePanel.classList.add("open");
      mobileToggle.setAttribute("aria-expanded", "true");
      // Search and the burger menu are mutually exclusive.
      if (burger) burger.style.display = "none";
      document.body.classList.add("overflow-hidden");
      focusInput(mobilePanel);
    }

    function closeMobile(restoreFocus) {
      if (!mobilePanel) return;

      mobilePanel.classList.remove("open");
      if (mobileToggle) mobileToggle.setAttribute("aria-expanded", "false");
      if (burger) burger.style.display = "";
      document.body.classList.remove("overflow-hidden");

      if (restoreFocus && mobileToggle) mobileToggle.focus();
    }

    function bindToggle(toggle, isOpen, open, close) {
      if (!toggle) return;

      toggle.addEventListener("click", (event) => {
        // Let modifier and middle clicks follow the href to the search page.
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.button > 0
        ) {
          return;
        }

        event.preventDefault();
        if (isOpen()) close(false);
        else open();
      });

      // A link does not fire click on Space; the level-0 items are buttons and
      // do, so shim it to keep the keyboard behaviour identical.
      toggle.addEventListener("keydown", (event) => {
        if (event.key !== " " && event.key !== "Spacebar") return;
        event.preventDefault();
        toggle.click();
      });
    }

    bindToggle(desktopToggle, isDesktopOpen, openDesktop, closeDesktop);
    bindToggle(mobileToggle, isMobileOpen, openMobile, closeMobile);

    // No burger listener is needed for mutual exclusion: openMobile() hides the
    // burger, so it cannot be reached while search is open.

    // Tap the dimmed area of the mobile panel to close. The desktop panel needs
    // no equivalent: the document click handler in initFlyoutMenu() already
    // closes on a click outside .flyout-overlay-wrapper.
    if (mobilePanel) {
      mobilePanel.addEventListener("click", (event) => {
        if (event.target === mobilePanel) closeMobile(true);
      });
    }

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" && event.key !== "Esc") return;

      if (isMobileOpen()) closeMobile(true);
      else if (isDesktopOpen()) closeDesktop(true);
    });
  }

  /**
   * Secondary nav sticky/fixed logic
   */
  function initSecondaryNav() {
    const navbar = document.querySelector(".navbar");
    const adminBar = document.querySelector(".top-bar.gin--navigation-top-bar");

    const secondaryNav = document.querySelector(".secondary-nav");

    if (!secondaryNav) {
      return;
    }

    const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;

    const adminBarHeight = adminBar
      ? adminBar.getBoundingClientRect().height
      : 0;

    const offsetTop = navbarHeight + adminBarHeight;

    document.documentElement.style.setProperty(
      "--navbar-secondarybar-height",
      `${offsetTop}px`,
    );

    const secondaryNavHeight = secondaryNav
      ? secondaryNav.getBoundingClientRect().height
      : 0;
    document.documentElement.style.setProperty(
      "--secondaryNav-height",
      `-${secondaryNavHeight}px`,
    );

    const initialTop =
      secondaryNav.getBoundingClientRect().top + window.scrollY;

    function handleScroll() {
      if (window.scrollY >= initialTop - offsetTop) {
        secondaryNav.classList.add("is-fixed");
        secondaryNav.classList.add("bg-gradient-light-dark-diagonal-primary");
      } else {
        secondaryNav.classList.remove("is-fixed");
        secondaryNav.classList.remove(
          "bg-gradient-light-dark-diagonal-primary",
        );
      }
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();
  }

  window.addEventListener("resize", () => {
    initFlyoutMenu();
    initSecondaryNav();
  });

  function secondaryNavDropdown() {
    const secondaryNavMenu = document.querySelector(".secondary-nav__menu");

    document
      .querySelectorAll(".secondary-nav .btn-group")
      .forEach((dropdown) => {
        const toggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
        const menu = dropdown.querySelector(".dropdown-menu");

        if (!toggle || !menu) {
          return;
        }

        // Prevent duplicated listeners.
        if (dropdown.dataset.dropdownInitialized) {
          return;
        }

        dropdown.dataset.dropdownInitialized = "true";

        dropdown.addEventListener("show.bs.dropdown", () => {
          document.body.appendChild(menu);

          const rect = toggle.getBoundingClientRect();

          menu.style.position = "fixed";
          menu.style.top = "-2px";
          menu.style.left = `${rect.left}px`;
          menu.style.zIndex = "1";
        });

        dropdown.addEventListener("hide.bs.dropdown", () => {
          dropdown.appendChild(menu);

          menu.removeAttribute("style");
        });
      });

    if (secondaryNavMenu && !secondaryNavMenu.dataset.scrollInitialized) {
      secondaryNavMenu.dataset.scrollInitialized = "true";

      let lastScrollLeft = secondaryNavMenu.scrollLeft;
      let lastScrollTop = window.scrollY;

      const closeDropdowns = () => {
        document.body.click();
      };

      secondaryNavMenu.addEventListener("scroll", () => {
        const currentScrollLeft = secondaryNavMenu.scrollLeft;
        const currentScrollTop = window.scrollY;

        const horizontalScrollChanged =
          Math.abs(currentScrollLeft - lastScrollLeft) > 0;

        const verticalScrollChanged =
          Math.abs(currentScrollTop - lastScrollTop) > 0;

        if (horizontalScrollChanged || verticalScrollChanged) {
          closeDropdowns();
        }

        lastScrollLeft = currentScrollLeft;
        lastScrollTop = currentScrollTop;
      });

      window.addEventListener("scroll", closeDropdowns, { passive: true });
    }
  }

  // Flyout menu should be loaded when DOM is ready.
  window.addEventListener("load", () => {
    initFlyoutMenu();
    // Bound once for both breakpoints; deliberately not called on resize.
    initSearchFlyout();
    // If SecondaryNav, then custom Sticky, and custom close Dropdown.
    initSecondaryNav();
    secondaryNavDropdown();
  });
});
